import { createCheckDate } from "@/utils";
import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const checkInAtom = atom({
    default: createCheckDate().currentDateString,
    key: ATOM_KEY.CHECK_IN,
});

const checkOutAtom = atom({
    default: createCheckDate().nextDateString,
    key: ATOM_KEY.CHECK_OUT,
});
const checkCountAtom = atom({
    default: 0,
    key: ATOM_KEY.CHECK_COUNT,
});

export const useCheckCountState = () => useRecoilState(checkCountAtom);
export const useCheckCountValue = () => useRecoilValue(checkCountAtom);

export const useCheckInState = () => useRecoilState(checkInAtom);
export const useCheckInValue = () => useRecoilValue(checkInAtom);
export const useSetCheckInState = () => useSetRecoilState(checkInAtom);

export const useCheckOutState = () => useRecoilState(checkOutAtom);
export const useCheckOutValue = () => useRecoilValue(checkOutAtom);
export const useSetCheckOutState = () => useSetRecoilState(checkOutAtom);
